import * as types from "../mutation-types";
import {resetStoreState} from "@/store/storeUtils";
import {enumDef} from "@/common/enumDefs";
import {localization} from "@/common/lang/localization";
import {formatAsCountryName, formatAsIndustryText} from "@/common/format";

const defaultState = {
	config: {
		receivableConditions: [],
		generalLimits: [],
		specialLimits: [],
		specialLimitConditions: [],

		allowedDebtorCompanies: [],
		allowedDebtorCountries: [],
		allowedSellerCompanies: [],
		allowedSellerCountries: [],
		allowedIndustryIds: [],

		showCoverage: false,
	},
	configLoaded: false,
	valueOptionsByType: {}
};

const state = {
	...defaultState
};

const getters = {
	config(state) {
		return state.config;
	},
	configLoaded(state) {
		return state.configLoaded;
	},
	valueOptions(state) {
		return (valueType) => {
			return state.valueOptionsByType[valueType];
		}
	}
};

const actions = {
	setActionConfig({
		commit
	}, payload) {
		commit(types.SET_ALFA_CONFIG, payload)
	},
};

const mutations = {
	[types.SET_ALFA_CONFIG](state, config) {
		state.config = config;

		state.valueOptionsByType[enumDef.alfaValueType.AssignmentType] = {
			values: [
				{
					disclosed: true ,
					translation: localization.i18n.t(enumDef.disclosedType.properties[enumDef.disclosedType.Disclosed].key)
				},
				{
					disclosed: false ,
					translation: localization.i18n.t(enumDef.disclosedType.properties[enumDef.disclosedType.Undisclosed].key)
				}
			],
			valueField: "disclosed",
			displayField: "translation"
		};

		state.valueOptionsByType[enumDef.alfaValueType.RiskCategory] = {
			values: Object.keys(enumDef.riskCategory.properties)
				.filter(riskCategory => Number(riskCategory) !== enumDef.riskCategory.VeryHigh)
				.map(riskCategory => {
					return {
						riskCategory: Number(riskCategory),
						translation: localization.i18n.t(enumDef.riskCategory.properties[riskCategory].key)
					}
				}),
			valueField: "riskCategory",
			displayField: "translation"
		};

		state.valueOptionsByType[enumDef.alfaValueType.DebtorCompany] = {
			values: config.allowedDebtorCompanies.map(company => {
				return {
					id: company.id,
					displayName: company.name + " (" + company.vatNumber + ")"
				};
			}),
			valueField: "id",
			displayField: "displayName"
		};

		state.valueOptionsByType[enumDef.alfaValueType.DebtorCountry] = {
			values: config.allowedDebtorCountries.map(countryCode => {
				return {
					code: countryCode,
					translation: formatAsCountryName(countryCode)
				};
			}),
			valueField: "code",
			displayField: "translation"
		};

		state.valueOptionsByType[enumDef.alfaValueType.SellerCompany] = {
			values: config.allowedSellerCompanies.map(company => {
				return {
					id: company.id,
					displayName: company.name + " (" + company.vatNumber + ")"
				};
			}),
			valueField: "id",
			displayField: "displayName"
		};

		state.valueOptionsByType[enumDef.alfaValueType.SellerCountry] = {
			values: config.allowedSellerCountries.map(countryCode => {
				return {
					code: countryCode,
					translation: formatAsCountryName(countryCode)
				};
			}),
			valueField: "code",
			displayField: "translation"
		};

		state.valueOptionsByType[enumDef.alfaValueType.Industry] = {
			values: config.allowedIndustryIds.map(id => {
				return {
					id: id,
					translation: formatAsIndustryText(id)
				};
			}),
			valueField: "id",
			displayField: "translation"
		};

		// Not used but added for completeness
		state.valueOptionsByType[enumDef.alfaValueType.Number] = {};
		state.valueOptionsByType[enumDef.alfaValueType.PercentageRate] = {};

		state.configLoaded = true;
	},

	initState(state) {
		resetStoreState(state, defaultState);
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};